<div class="home-container">
  <section>
    <app-welcome />
  </section>
</div>
